import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const IntroSection = () => {
  const { t, language } = useLanguage();
  
  return (
    <section className="py-16 px-4 bg-white">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-teal-500 mb-6">
          {t('heroTitle')}
        </h2>
        <p className="text-gray-600 leading-relaxed text-base md:text-lg">
          {language === 'es' ? (
            <>
              Le invitamos a vivir una experiencia inolvidable, un recorrido por toda{' '}
              <strong className="text-gray-800">República Dominicana</strong>, donde podrá disfrutar de las
              más hermosas playas de arenas blancas, paisajes únicos e impresionantes, gente
              increíble, eventos, shows… y todo{' '}
              <strong className="text-gray-800">al mejor precio</strong>, para el disfrute de toda la
              familia. <em className="text-gray-700">No se pierda la experiencia</em>, le aseguramos que
              República Dominicana lo tiene TODO.
            </>
          ) : (
            <>
              We invite you to live an unforgettable experience, a tour through all of{' '}
              <strong className="text-gray-800">Dominican Republic</strong>, where you can enjoy the
              most beautiful white sand beaches, unique and impressive landscapes, incredible
              people, events, shows... and all at{' '}
              <strong className="text-gray-800">the best price</strong>, for the enjoyment of the whole
              family. <em className="text-gray-700">Don't miss the experience</em>, we assure you that
              the Dominican Republic has it ALL.
            </>
          )}
        </p>
      </div>
    </section>
  );
};

export default IntroSection;
